
import { createContext, useEffect, useState } from "react";
import { Snackbar, Alert, Slide } from '@mui/material';

export const ErrorContext = createContext();

export const ErrorProvider = ({ children }) => {
    const [error, setError] = useState(null);
    const [severity, setSeverity] = useState('error');

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setError(null);
        setSeverity('error'); // Reset severity when closing
    };

    // Determine if the message is a loading message
    const isLoadingMessage = (message) => {
        return message && (message.toLowerCase().includes('loading') ||
                          message.toLowerCase().includes('analyzing') ||
                          message.toLowerCase().includes('processing'));
    };

    // Determine if the message is a success message
    const isSuccessMessage = (message) => {
        return message && (message.toLowerCase().includes('successfully') ||
                          message.toLowerCase().includes('uploaded') ||
                          message.toLowerCase().includes('complete') ||
                          message.toLowerCase().includes('checking status') ||
                          (message.toLowerCase().includes('processing') && 
                           message.toLowerCase().includes('checking')));
    };

    // Get the appropriate severity based on message content
    const getSeverity = (message) => {
        if (!message) return severity; // Use stored severity if message is null
        if (isSuccessMessage(message)) return 'success';
        return isLoadingMessage(message) ? 'warning' : 'error';
    };

    // Update severity when error changes
    useEffect(() => {
        if (error) {
            if (isSuccessMessage(error)) {
                setSeverity('success');
            } else {
                setSeverity(isLoadingMessage(error) ? 'warning' : 'error');
            }
        }
    }, [error]);

    return (<ErrorContext.Provider value={{ setError }}>
        <Snackbar
            open={!!error}
            autoHideDuration={4000}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            slots={{ transition: Slide }}
        >
            <Alert
                onClose={handleClose}
                severity={getSeverity(error)}
                variant="filled"
                sx={{
                    width: '100%',
                    fontSize: '0.95rem',
                    fontWeight: 500,
                    borderRadius: 2,
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    '& .MuiAlert-icon': {
                        fontSize: '1.2rem'
                    }
                }}
            >
                {error}
            </Alert>
        </Snackbar>
        {children}
    </ErrorContext.Provider>)

};
